import { render, staticRenderFns } from "./ChipStatusIntegracao.vue?vue&type=template&id=6cc0f9c6&scoped=true"
import script from "./ChipStatusIntegracao.vue?vue&type=script&lang=js"
export * from "./ChipStatusIntegracao.vue?vue&type=script&lang=js"
import style0 from "./ChipStatusIntegracao.vue?vue&type=style&index=0&id=6cc0f9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc0f9c6",
  null
  
)

export default component.exports